import { FaceTecCdnPaths } from '@/services/facetec-sdk-loader'
import { resolveBiometricTheme, resolveBiometricFont } from '@/config/biometricTheme'

const configurationComponentFace = (FaceTecSDK, logoURI, client) => {
  var sdkImageDirectory = `${FaceTecCdnPaths.imagesUrl}/`

  // Paleta unica dos fluxos biometricos: o que a API enviar prevalece,
  // o restante cai no default da proposta de UX (azul = normal, amarelo = ajuste).
  const theme = resolveBiometricTheme(client)
  const fonte = resolveBiometricFont(client)

  var outerBackgroundColor = theme.surface
  var frameColor = theme.surface
  var borderColor = theme.surface
  var ovalColor = theme.ovalNormal
  var adjustColor = theme.ovalAdjust
  var dualSpinnerColor = theme.progressFill
  var textColor = theme.textPrimary
  var buttonAndFeedbackBarColor = theme.feedbackBackground
  var buttonAndFeedbackBarTextColor = theme.feedbackText
  var buttonColorHighlight = theme.buttonHighlight
  var buttonColorDisabled = theme.buttonDisabled
  var buttonTextColorDisabled = theme.buttonTextDisabled

  // For Frame Corner Radius Customization
  const frameCornerRadius = '20px'

  // For Cancel Button Customization
  var cancelButtonImage = sdkImageDirectory + 'FaceTec_cancel.png'
  var cancelButtonLocation = FaceTecSDK.FaceTecCancelButtonLocation.TopRight

  // For image Customization
  var securityWatermarkImage = FaceTecSDK.FaceTecSecurityWatermarkImage.FaceTec_ZoOm

  // Set a default customization
  var defaultCustomization = new FaceTecSDK.FaceTecCustomization()

  // Set Frame Customization
  defaultCustomization.frameCustomization.borderCornerRadius = frameCornerRadius
  defaultCustomization.frameCustomization.backgroundColor = frameColor
  defaultCustomization.frameCustomization.borderColor = borderColor

  // Set Overlay Customization
  defaultCustomization.overlayCustomization.brandingImage = logoURI
  defaultCustomization.overlayCustomization.backgroundColor = outerBackgroundColor

  // Set Guidance Customization
  defaultCustomization.guidanceCustomization.backgroundColors = frameColor
  defaultCustomization.guidanceCustomization.foregroundColor = textColor
  defaultCustomization.guidanceCustomization.buttonBackgroundNormalColor = buttonAndFeedbackBarColor
  defaultCustomization.guidanceCustomization.buttonBackgroundDisabledColor = buttonColorDisabled
  defaultCustomization.guidanceCustomization.buttonBackgroundHighlightColor = buttonColorHighlight
  defaultCustomization.guidanceCustomization.buttonTextNormalColor = buttonAndFeedbackBarTextColor
  defaultCustomization.guidanceCustomization.buttonTextDisabledColor = buttonTextColorDisabled
  defaultCustomization.guidanceCustomization.buttonTextHighlightColor = buttonAndFeedbackBarTextColor
  defaultCustomization.guidanceCustomization.retryScreenImageBorderColor = adjustColor
  defaultCustomization.guidanceCustomization.retryScreenOvalStrokeColor = adjustColor

  // Set Oval Customization
  defaultCustomization.ovalCustomization.strokeColor = ovalColor
  defaultCustomization.ovalCustomization.progressColor1 = dualSpinnerColor
  defaultCustomization.ovalCustomization.progressColor2 = dualSpinnerColor

  // Set Feedback Customization
  defaultCustomization.feedbackCustomization.backgroundColor = buttonAndFeedbackBarColor
  defaultCustomization.feedbackCustomization.textColor = buttonAndFeedbackBarTextColor

  // Set Cancel Customization
  defaultCustomization.cancelButtonCustomization.customImage = cancelButtonImage
  defaultCustomization.cancelButtonCustomization.location = cancelButtonLocation

  // Set Security Watermark Customization
  defaultCustomization.securityWatermarkCustomization.setSecurityWatermarkImage(securityWatermarkImage)

  // Set Result Screen Customization
  defaultCustomization.resultScreenCustomization.backgroundColors = frameColor
  defaultCustomization.resultScreenCustomization.foregroundColor = textColor
  defaultCustomization.resultScreenCustomization.activityIndicatorColor = theme.progressFill
  defaultCustomization.resultScreenCustomization.resultAnimationBackgroundColor = buttonAndFeedbackBarColor
  defaultCustomization.resultScreenCustomization.resultAnimationForegroundColor = buttonAndFeedbackBarTextColor
  defaultCustomization.resultScreenCustomization.uploadProgressFillColor = theme.progressFill

  // Set ID Scan Customization
  defaultCustomization.idScanCustomization.selectionScreenBackgroundColors = frameColor
  defaultCustomization.idScanCustomization.selectionScreenForegroundColor = textColor
  defaultCustomization.idScanCustomization.reviewScreenBackgroundColors = frameColor
  defaultCustomization.idScanCustomization.reviewScreenForegroundColor = buttonAndFeedbackBarTextColor
  defaultCustomization.idScanCustomization.reviewScreenTextBackgroundColor = buttonAndFeedbackBarColor
  defaultCustomization.idScanCustomization.captureScreenForegroundColor = buttonAndFeedbackBarTextColor
  defaultCustomization.idScanCustomization.captureScreenTextBackgroundColor = buttonAndFeedbackBarColor
  defaultCustomization.idScanCustomization.buttonBackgroundNormalColor = buttonAndFeedbackBarColor
  defaultCustomization.idScanCustomization.buttonBackgroundDisabledColor = buttonColorDisabled
  defaultCustomization.idScanCustomization.buttonBackgroundHighlightColor = buttonColorHighlight
  defaultCustomization.idScanCustomization.buttonTextNormalColor = buttonAndFeedbackBarTextColor
  defaultCustomization.idScanCustomization.buttonTextDisabledColor = buttonTextColorDisabled
  defaultCustomization.idScanCustomization.buttonTextHighlightColor = buttonAndFeedbackBarTextColor
  defaultCustomization.idScanCustomization.captureScreenBackgroundColor = frameColor
  defaultCustomization.idScanCustomization.captureFrameStrokeColor = adjustColor

  // Set Initial Loading Customization
  defaultCustomization.initialLoadingAnimationCustomization.backgroundColor = theme.progressTrack
  defaultCustomization.initialLoadingAnimationCustomization.foregroundColor = theme.progressFill

  // Tipografia: o SDK fixa 'Source Sans Pro' nestes sete grupos, fazendo a
  // captura destoar do resto do portal. Só a família é trocada — os tamanhos
  // continuam sendo os do SDK, que não os expõe na API de customização.
  defaultCustomization.guidanceCustomization.headerFont = fonte
  defaultCustomization.guidanceCustomization.subtextFont = fonte
  defaultCustomization.guidanceCustomization.buttonFont = fonte
  defaultCustomization.guidanceCustomization.readyScreenHeaderFont = fonte
  defaultCustomization.guidanceCustomization.readyScreenSubtextFont = fonte
  defaultCustomization.guidanceCustomization.retryScreenHeaderFont = fonte
  defaultCustomization.guidanceCustomization.retryScreenSubtextFont = fonte
  defaultCustomization.resultScreenCustomization.messageFont = fonte
  defaultCustomization.initialLoadingAnimationCustomization.messageFont = fonte
  defaultCustomization.enterFullScreenCustomization.headerFont = fonte
  defaultCustomization.enterFullScreenCustomization.subtextFont = fonte
  defaultCustomization.enterFullScreenCustomization.buttonFont = fonte
  defaultCustomization.idScanCustomization.headerFont = fonte
  defaultCustomization.idScanCustomization.subtextFont = fonte
  defaultCustomization.idScanCustomization.buttonFont = fonte
  defaultCustomization.ocrConfirmationCustomization.mainHeaderFont = fonte
  defaultCustomization.ocrConfirmationCustomization.sectionHeaderFont = fonte
  defaultCustomization.ocrConfirmationCustomization.fieldLabelFont = fonte
  defaultCustomization.ocrConfirmationCustomization.fieldValueFont = fonte
  defaultCustomization.ocrConfirmationCustomization.buttonFont = fonte
  defaultCustomization.ocrConfirmationCustomization.scrollIndicatorFont = fonte

  // A faixa de feedback usa o atalho `font`, com métricas próprias do SDK.
  // Preservamos peso e tamanho para não quebrar o layout da faixa.
  defaultCustomization.feedbackCustomization.textFont = `normal bold 22px/50px ${fonte}`

  return defaultCustomization
}
export { configurationComponentFace }
